import { render, staticRenderFns } from "./NewFacebookIcon.vue?vue&type=template&id=9a61a146&scoped=true"
import script from "./NewFacebookIcon.vue?vue&type=script&lang=js"
export * from "./NewFacebookIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a61a146",
  null
  
)

export default component.exports